<template>
  <el-container>
    <el-header height="80px">
      <el-menu class="el-menu-demo" :default-active="activeIndex" mode="horizontal" id="elMenu" @select="handleSelect">
        <el-menu-item @click="back()">后退</el-menu-item>
        <el-menu-item index="/hangzhouwanIndex">首页</el-menu-item>
        <el-submenu index="/hangzhouwan/gasClamp">
          <template slot="title">全桥实时数据</template>
          <el-menu-item index="/hangzhouwan/gasClamp/ramp">匝道桥</el-menu-item>
          <el-menu-item index="/hangzhouwan/gasClamp/northChannelNorthTower">北航道北塔区</el-menu-item>
          <el-menu-item index="/hangzhouwan/gasClamp/northChannelSouthTower">北航道南塔区</el-menu-item>
          <el-menu-item index="/hangzhouwan/gasClamp/southChannelMainTower">南航道桥</el-menu-item>
        </el-submenu>
        <el-submenu index="/hangzhouwan/ramp">
          <template slot="title">匝道除湿机</template>
          <el-menu-item index="/hangzhouwan/ramp/A1">A1匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/A2">A2匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/B1">B1匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/B2">B2匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/B3">B3匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/B4">B4匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/C1">C1匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/C2">C2匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/C3">C3匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/C4">C4匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/D1">D1匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/D2">D2匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/D3">D3匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/D4">D4匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/E1">E1匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/E2">E2匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/E3">E3匝道除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/ramp/E4">E4匝道除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/hangzhouwan/tower">
          <template slot="title">主塔除湿机</template>
          <el-menu-item index="/hangzhouwan/tower/northChannelNorthTower">北航道北塔NT1#除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/tower/northChannelSouthTower">北航道南塔NT2#除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/tower/southChannelMainTower">南航道主塔ST1#除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/hangzhouwan/steelBox">
          <template slot="title">钢箱梁除湿机</template>
          <el-menu-item index="/hangzhouwan/steelBox/nn1nn2">北航道NN1#/NN2#除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/steelBox/nn3nn4">北航道NN3#/NN4#除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/steelBox/ns1ns2">北航道NS1#/NS2#除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/steelBox/ns3ns4">北航道NS3#/NS4#除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/steelBox/sn1sn2">南航道SN1#/SN2#除湿机</el-menu-item>
          <el-menu-item index="/hangzhouwan/steelBox/ss1ss2">南航道SS1#/SS2#除湿机</el-menu-item>
        </el-submenu>
        <el-submenu index="/hangzhouwan/ventilation">
          <template slot="title">新风/排风</template>
          <el-menu-item index="/hangzhouwan/ventilation/northChannel">北航道新风/排风</el-menu-item>
          <el-menu-item index="/hangzhouwan/ventilation/southChannel">南航道新风/排风</el-menu-item>
        </el-submenu>

        <!-- <el-submenu index="/sutong/nantongDehumidifer">
          <template slot="title">南通侧除湿机</template>
          <el-menu-item index="/sutong/nantong/dehumidifierSmall"
            >NA18梁段1-2号除湿机</el-menu-item
          >
          <el-menu-item index="/sutong/nantong/dehumidifierBig"
            >NJ16梁段3-4号除湿机</el-menu-item
          >
        </el-submenu>
        <el-submenu index="/sutong/changshu">
          <template slot="title">常熟侧除湿机</template>
          <el-menu-item index="/sutong/changshu/dehumidifierBig"
            >SJ16梁段5-6号除湿机</el-menu-item
          >
          <el-menu-item index="/sutong/changshu/dehumidifierSmall"
            >SA18梁段7-8号除湿机</el-menu-item
          >
        </el-submenu>
        <el-menu-item index="/sutong/ventilation">排风</el-menu-item> -->
        <el-menu-item index="/hangzhouwan/bridgeImg">全桥除湿总体布置图</el-menu-item>
        <el-submenu :index="'/hangzhouwan/dataHistory?bridgeId=af4efd47-4bf0-4ce4-b484-0003c5726b91&scenarioId=TBD'">
          <template slot="title">数据历史</template>
          <el-menu-item index="/hangzhouwan/dataHistory?bridgeId=af4efd47-4bf0-4ce4-b484-0003c5726b91&scenarioId=TBD"> 查询数据历史 </el-menu-item>
          <el-menu-item index="/hangzhouwan/dataHistory?bridgeId=af4efd47-4bf0-4ce4-b484-0003c5726b91"> 自定义数据历史 </el-menu-item>
        </el-submenu>
      </el-menu>
      <HeaderTime bridgeName="HANGZHOU" :bridgeId="bridgeId" :id2Path="id2Path" :envInfo="envInfo"></HeaderTime>
    </el-header>
    <el-main class="el-main hang-zhou-wan">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>
<script>
export default {
  name: "hangzhouwan",
  data() {
    return {
      bridgeId: "af4efd47-4bf0-4ce4-b484-0003c5726b91",
      envInfo: {
        envId: "c4335a5c-07cf-4545-b977-1846fdc31171",
        weather: "8bbfb4ec-1614-4d54-9714-24c084a104be",
        humidity: "42c81b06-09bb-4704-b967-fe21c523a7a9",
        temperature: "011fe014-26d9-4486-ad27-4c22763072f9",
      },
      id2Path: {},
      activeIndex: "",
      historyScenarioList: [],
    };
  },
  mounted() {
    this.activeIndex = this.$route.fullPath;

    document.getElementById("elMenu").addEventListener(
      "mousewheel",
      (e) => {
        let scrollWidth = document.getElementById("elMenu").scrollWidth;
        let clientWidth = document.getElementById("elMenu").clientWidth;

        let scrollMin = 0;
        let scrollMax = scrollWidth - clientWidth;
        let step = 30;

        if (e.deltaY > 0) {
          document.getElementById("elMenu").scrollLeft += step;
          if (document.getElementById("elMenu").scrollLeft > scrollMax) {
            document.getElementById("elMenu").scrollLeft = scrollMax;
          }
        } else if (e.deltaY < 0) {
          document.getElementById("elMenu").scrollLeft += step * -1;
          if (document.getElementById("elMenu").scrollLeft < scrollMin) {
            document.getElementById("elMenu").scrollLeft = scrollMin;
          }
        }
      },
      true
    );
  },
  watch: {
    $route() {
      this.activeIndex = this.$route.fullPath;
    },
  },
  methods: {
    back() {
      window.history.back();
    },
    handleSelect(key) {
      if (key !== this.activeIndex) {
        this.activeIndex = key;
        this.$router.push(key);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.el-menu-demo {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-start;
  align-items: center;

  overflow-x: scroll;
}

::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  background: transparent;;
  display: none;
}
</style>